const InfoBoxLayoutType = {
  ParagraphFollowedBySingleList: 1
};

export default InfoBoxLayoutType;
